import { useContext } from "react"
import { PerguntaPesquisaSatisfacaoContext } from "./PerguntaPesquisaSatisfacaoContext"

export function usePerguntaPesquisaSatisfacaoContext() {
    return useContext(PerguntaPesquisaSatisfacaoContext)
}
